module.exports = __webpack_public_path__ + "img/slide-9.5b8c2fba.jpg";